import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
export var tooltip = {
  CLICK: 'click',
  HOVER: 'hover'
};
tooltip.ALL = _valuesInstanceProperty(_).call(_, tooltip);
//# sourceMappingURL=triggerEvents.js.map